import React from 'react';
import { Shirt, Calendar, Award, Check } from 'lucide-react';
export function TrialDetails() {
  return <div className="space-y-8" data-id="element-289">
      <div data-id="element-290">
        <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-291">
          What's Included
        </h3>
        <div className="space-y-6" data-id="element-292">
          <div className="flex" data-id="element-293">
            <div className="flex-shrink-0 mr-4" data-id="element-294">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-295">
                <Calendar className="w-5 h-5 text-primary" data-id="element-296" />
              </div>
            </div>
            <div data-id="element-297">
              <h4 className="text-lg font-semibold text-gray-900" data-id="element-298">
                4 Weeks of Classes
              </h4>
              <p className="text-gray-600" data-id="element-299">
                Unlimited access to age-appropriate classes for 4 consecutive
                weeks.
              </p>
            </div>
          </div>

          <div className="flex" data-id="element-300">
            <div className="flex-shrink-0 mr-4" data-id="element-301">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-302">
                <Shirt className="w-5 h-5 text-accent" data-id="element-303" />
              </div>
            </div>
            <div data-id="element-304">
              <h4 className="text-lg font-semibold text-gray-900" data-id="element-305">
                Official Uniform
              </h4>
              <p className="text-gray-600" data-id="element-306">
                Receive a high-quality student uniform ($50 value) to wear
                during training.
              </p>
            </div>
          </div>

          <div className="flex" data-id="element-307">
            <div className="flex-shrink-0 mr-4" data-id="element-308">
              <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-309">
                <Award className="w-5 h-5 text-purple-600" data-id="element-310" />
              </div>
            </div>
            <div data-id="element-311">
              <h4 className="text-lg font-semibold text-gray-900" data-id="element-312">
                1 Promotion
              </h4>
              <p className="text-gray-600" data-id="element-313">
                Opportunity to test for your first rank advancement during the
                trial.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-xl" data-id="element-314">
        <h4 className="font-semibold text-gray-900 mb-3" data-id="element-315">Why Start Now?</h4>
        <ul className="space-y-2" data-id="element-316">
          <li className="flex items-center text-sm text-gray-600" data-id="element-317">
            <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-318" />
            No long-term contracts required
          </li>
          <li className="flex items-center text-sm text-gray-600" data-id="element-319">
            <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-320" />
            Beginner-friendly environment
          </li>
          <li className="flex items-center text-sm text-gray-600" data-id="element-321">
            <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-322" />
            Small class sizes for personal attention
          </li>
        </ul>
      </div>
    </div>;
}